import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import ShipperSidebar from '../shipper/Sidebar';
import ManageNotifications from '../notifications/manage-notifications';
import SessionStore from '../../../stores/SessionStore';
import Container from '../../v2/container';

const NotificationsPage = () => {
  const [type, setType] = useState(null);

  useEffect(() => {
    setType(SessionStore.getUserType());
  }, []);

  return (
    <Container>
      <div className="lg:grid lg:grid-cols-12 lg:gap-6 mt-10">
        <div className="lg:col-span-3">
          {type === 'Carrier' && <Sidebar activePage="notifications" />}
          {type === 'Shipper' && <ShipperSidebar activePage="notifications" />}
        </div>
        <div className="lg:col-span-9">
          <ManageNotifications />
        </div>
      </div>
    </Container>
  );
};

export default NotificationsPage;
